
import React from 'react'
import { Container } from 'react-bootstrap';
import Bounce from 'react-reveal/Bounce';







export const Accessibility = () => (
   <Container>

 <div style={styles.container}>
      <Bounce right>
        <div style={styles.card}>
          {/* כותרת קטנה או קו דקורטיבי להדגשה */}
          <div style={styles.decorator}></div>
          
          <div style={styles.content}>
            <p style={styles.highlightText}>
              בהתאם לחוק הנגישות, לשם קבלת היתר זמני, רישיון עסק או חידוש רישיון:
            </p>
            
            <p style={styles.mainText}>
              ערים מסוימות מחייבות את העסקים לעמוד בדרישות הנגישות בהתאם לחוק 
              <span style={styles.boldBlue}> שיוויון זכויות לאנשים עם מוגבלויות </span> 
              ותקנותיו.
            </p>

            <div style={styles.infoBox}>
              <p style={styles.infoText}>
                על בעל העסק להגיש חוות דעת של <strong>מורשה נגישות מתו"ס</strong> (מבנים, תשתיות וסביבה) 
                ו<strong>מורשה נגישות השירות</strong>, אשר יבחנו בהתאם להוראות הדין על ידי מורשה נגישות מטעם הרשות.
              </p>
            </div>
          </div>
        </div>
      </Bounce>
    </div>
  


</Container>
  
  
  
  
  )
  
  
const styles = {
  container: {
    direction: 'rtl',
    padding: '40px 20px',
    display: 'flex',
    justifyContent: 'center',
  },
  card: {
    maxWidth: '800px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    position: 'relative',
    border: '1px solid #f0f0f0',
  },
  decorator: {
    height: '6px',
    width: '100%',
    backgroundColor: '#3498db', // כחול מקצועי
    backgroundImage: 'linear-gradient(to left, #3498db, #2ecc71)', // גרדיאנט עדין
  },
  content: {
    padding: '40px',
    textAlign: 'right',
  },
  highlightText: {
    fontSize: '1.2rem',
    color: '#2c3e50',
    fontWeight: '600',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
  mainText: {
    fontSize: '1.1rem',
    color: '#546e7a',
    lineHeight: '1.8',
    marginBottom: '25px',
  },
  boldBlue: {
    color: '#2980b9',
    fontWeight: '700',
  },
  infoBox: {
    backgroundColor: '#f8fafc',
    padding: '20px',
    borderRadius: '12px',
    borderRight: '4px solid #3498db',
  },
  infoText: {
    fontSize: '1rem',
    color: '#455a64',
    margin: 0,
    lineHeight: '1.7',
  }
};
